(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["obrelle-models-gallery"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('obrelle-models-gallery')) {
    customElements.define('obrelle-models-gallery', class extends HTMLElement {
      connectedCallback() {
        if (this.abort) return;
        if (!this.querySelector('.obrelle-models__viewer')) { requestAnimationFrame(() => { if (this.isConnected) this.connectedCallback(); }); return; }
        this.abort = new AbortController();
        const options = { signal: this.abort.signal };
        this.dialog = this.querySelector('dialog');
        this.trigger = this.querySelector('.obrelle-models__trigger');
        this.viewer = this.querySelector('.obrelle-models__viewer');
        this.counter = this.querySelector('.obrelle-models__count');
        this.originalLabel = this.trigger.textContent.trim();
        this.mediaHost = this.closest('.product-information__grid')?.querySelector('.product-information__media');
        this.usePopup = this.dataset.popup === 'true' || !this.mediaHost;
        this.nativePlayback = new Map();
        if (this.usePopup) {
          this.trigger.removeAttribute('aria-pressed');
          this.trigger.setAttribute('aria-haspopup', 'dialog');
          this.trigger.setAttribute('aria-controls', this.dialog.id);
        }
        this.slides = [...this.querySelectorAll('.obrelle-model-photo:not(.obrelle-model-photo--placeholder)')];
        this.allSlides = [...this.querySelectorAll('.obrelle-model-photo')];
        this.previous = this.querySelector('.obrelle-models__previous');
        this.next = this.querySelector('.obrelle-models__next');
        this.footer = this.querySelector('.obrelle-models__footer');
        this.play = this.querySelector('.obrelle-models__play');
        this.reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
        this.paused = this.reducedMotion.matches;
        this.index = 0;
        this.show(0);
        this.trigger.addEventListener('click', () => {
          this.editorSelection = false;
          if (this.inlineActive) { this.leaveInline(); return; }
          this.show(0); this.openViewer(); this.restart();
        }, options);
        this.querySelector('.obrelle-models__close').addEventListener('click', () => this.dialog.close(), options);
        this.previous.addEventListener('click', () => this.move(-1), options);
        this.next.addEventListener('click', () => this.move(1), options);
        this.play.addEventListener('click', () => { this.paused = !this.paused; this.restart(); }, options);
        this.viewer.addEventListener('keydown', event => {
          if (event.key === 'Escape' && this.inlineActive) { event.preventDefault(); this.leaveInline(); this.trigger.focus({ preventScroll: true }); }
          if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') { event.preventDefault(); this.move(event.key === 'ArrowLeft' ? 1 : -1); }
        }, options);
        const stage = this.querySelector('.obrelle-models__stage');
        stage.addEventListener('pointerdown', event => { this.touchStart = { x: event.clientX, y: event.clientY }; this.stop(); }, options);
        stage.addEventListener('pointerup', event => {
          if (this.touchStart) {
            const dx = event.clientX - this.touchStart.x;
            const dy = event.clientY - this.touchStart.y;
            if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) this.move(dx > 0 ? 1 : -1);
          }
          this.touchStart = null; this.restart();
        }, options);
        stage.addEventListener('pointercancel', () => { this.touchStart = null; this.restart(); }, options);
        stage.addEventListener('mouseenter', () => { if (matchMedia('(hover: hover)').matches) { this.hovered = true; this.stop(); } }, options);
        stage.addEventListener('mouseleave', () => { this.hovered = false; this.restart(); }, options);
        this.dialog.addEventListener('click', event => {
          const rect = this.dialog.getBoundingClientRect();
          if (event.target === this.dialog && (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom)) this.dialog.close();
        }, options);
        this.dialog.addEventListener('close', () => { this.stop(); this.hovered = false; this.trigger.focus({ preventScroll: true }); }, options);
        document.addEventListener('visibilitychange', () => this.restart(), options);
        window.addEventListener('resize', () => { if (this.inlineActive) this.measureNative(); }, options);
        this.reducedMotion.addEventListener('change', () => { this.paused = this.reducedMotion.matches; this.restart(); }, options);
        document.addEventListener('shopify:block:select', event => {
          if (!this.contains(event.target) && !this.viewer.contains(event.target) && !event.target.contains(this)) return;
          this.editorSelection = true; this.stop();
          const selected = this.allSlides.find(slide => slide === event.target || slide.contains(event.target) || event.target.contains(slide));
          this.show(Math.max(0, this.slides.indexOf(selected)), selected);
          this.openViewer();
        }, options);
      }
      show(index, selected) {
        this.index = this.slides.length ? (index + this.slides.length) % this.slides.length : 0;
        const active = selected || this.slides[this.index];
        this.allSlides.forEach(slide => { const visible = slide === active; slide.classList.toggle('is-active', visible); slide.setAttribute('aria-hidden', String(!visible)); });
        const multiple = this.slides.length > 1 && !active?.classList.contains('obrelle-model-photo--placeholder');
        this.previous.hidden = this.next.hidden = this.footer.hidden = !multiple;
        this.counter.textContent = `${this.index + 1} / ${this.slides.length}`;
        active?.querySelector('img')?.setAttribute('loading', 'eager');
        this.slides[(this.index + 1) % this.slides.length]?.querySelector('img')?.setAttribute('loading', 'eager');
      }
      move(step) { this.editorSelection = false; this.show(this.index + step); this.restart(); }
      stop() { clearInterval(this.timer); this.timer = null; }
      restart() {
        this.stop();
        this.play.textContent = this.paused ? '▷' : 'Ⅱ';
        this.play.setAttribute('aria-label', this.paused ? this.play.dataset.play : this.play.dataset.pause);
        if ((this.dialog.open || this.inlineActive) && this.slides.length > 1 && !this.paused && !this.hovered && !this.editorSelection && !document.hidden) this.timer = setInterval(() => this.show(this.index + 1), 3000);
      }
      openViewer() {
        if (this.usePopup) { if (!this.dialog.open) this.dialog.showModal(); return; }
        if (this.inlineActive) return;
        this.measureNative();
        this.inlineActive = true;
        this.viewer.classList.add('obrelle-models__viewer--inline');
        this.mediaHost.append(this.viewer);
        this.mediaHost.setAttribute('data-obrelle-studio', '');
        this.trigger.textContent = this.dataset.returnLabel;
        this.trigger.setAttribute('aria-pressed', 'true');
        this.pauseNative();
        this.mediaObserver = new MutationObserver(records => {
          if (records.some(record => [...record.addedNodes].some(node => node.nodeName === 'MEDIA-GALLERY'))) {
            this.measureNative(); this.pauseNative();
          }
        });
        this.mediaObserver.observe(this.mediaHost, { childList: true });
      }
      measureNative() {
        const gallery = this.mediaHost?.querySelector('media-gallery');
        if (!gallery) return;
        const active = this.inlineActive;
        if (active) { this.viewer.hidden = true; this.mediaHost.removeAttribute('data-obrelle-studio'); }
        const bounds = gallery.getBoundingClientRect();
        if (bounds.width > 0 && bounds.height > 0) this.viewer.style.setProperty('--obrelle-inline-ratio', String(bounds.width / bounds.height));
        const radius = getComputedStyle(gallery).getPropertyValue('--media-radius').trim();
        this.viewer.style.setProperty('--obrelle-inline-radius', radius || '0px');
        if (active) { this.mediaHost.setAttribute('data-obrelle-studio', ''); this.viewer.hidden = false; }
      }
      pauseNative() {
        this.mediaHost.querySelectorAll('media-gallery slideshow-component').forEach(slideshow => {
          if (typeof slideshow.pause !== 'function') return;
          if (!this.nativePlayback.has(slideshow)) this.nativePlayback.set(slideshow, !slideshow.paused && Boolean(slideshow.autoplay));
          slideshow.pause();
        });
      }
      leaveInline() {
        this.stop(); this.hovered = false;
        if (!this.inlineActive) return;
        this.inlineActive = false;
        this.mediaObserver?.disconnect();
        this.dialog.append(this.viewer);
        this.viewer.classList.remove('obrelle-models__viewer--inline');
        this.mediaHost.removeAttribute('data-obrelle-studio');
        this.trigger.textContent = this.originalLabel;
        this.trigger.setAttribute('aria-pressed', 'false');
        this.nativePlayback.forEach((wasPlaying, slideshow) => {
          if (wasPlaying && slideshow.isConnected && typeof slideshow.play === 'function') slideshow.play();
        });
        this.nativePlayback.clear();
      }
      disconnectedCallback() {
        this.stop(); this.abort?.abort(); this.mediaObserver?.disconnect();
        this.leaveInline(); this.dialog?.close(); this.abort = null;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
